import React from 'react';
import '../../styles/components/LoadingScreen.css';

interface LoadingScreenProps {
  isVisible: boolean;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ isVisible }) => {
  return (
    <div
      className={`loading-screen ${!isVisible ? 'loading-screen--hidden' : ''}`}
      aria-hidden={!isVisible}
      role="status"
    >
      <div className="loading-screen__content">
        <div className="loading-screen__logo-wrapper">
          <span className="loading-screen__logo">Famini</span>
          <span
            className={`loading-screen__plus ${!isVisible ? 'loading-screen__plus--stopped' : ''}`}
            aria-hidden="true"
          >
            +
          </span>
        </div>
        <div className="loading-screen__spinner">
          <div className="loading-screen__spinner-track" />
          <div className="loading-screen__spinner-fill" />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
